import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { CINote } from './ci-note.model';
import { HttpService } from '../../shared/core/http.service';

@Injectable()
export class CINoteService {

    private noteAPIUrl = new URL('cinote', environment.apiUrl).toString();

    constructor(private _httpService: HttpService) { }

    getCINotes(clearanceItemId: string): Observable<CINote[]> {
        return this._httpService.httpGet(this.noteAPIUrl + '/getcinotes?clearanceItemId=' + clearanceItemId).pipe(
            map((data: any[]) => data.map(item => this.mapNote(item)))
        );
    }

    insert(note: CINote): Observable<CINote> {
        return this._httpService.httpPost(this.noteAPIUrl + '/insert', JSON.stringify(note)).pipe(
            map((response: any) => this.mapNote(response))
        );
    }

    update(note: CINote): Observable<CINote> {
        return this._httpService.httpPut(this.noteAPIUrl + '/update', JSON.stringify(note)).pipe(
            map((response: any) => this.mapNote(response))
        );
    }

    delete(id: number): Observable<boolean> {
        return this._httpService.httpDelete(this.noteAPIUrl + '/delete?id=' + id).pipe(
            map(() => true)
        );
    }

    markAsRead(clearanceItemId: string): Observable<any> {
        return this._httpService.httpPost(this.noteAPIUrl + '/markasread?clearanceItemId=' + clearanceItemId, '');
    }

    private mapNote(item: any): CINote {
        const note = new CINote();
        note.id = item.Id;
        note.sfClearanceItemId = item.SFClearanceItemId;
        note.description = item.Description;
        note.user = item.User;
        note.role = item.Role;
        note.createdById = item.CreatedById;
        note.createdDate = item.CreatedDate ? new Date(item.CreatedDate) : null;
        note.lastModifiedById = item.LastModifiedById;
        note.lastModifiedDate = item.LastModifiedDate ? new Date(item.LastModifiedDate) : null;
        note.isReadByProduction = item.IsReadByProduction === true;
        note.isReadByClearance = item.IsReadByClearance === true;
        return note;
    }
}
